export const MIDROLL_BREAKS_PER_SESSION = 'ads.acc.midrollBreaksPerSession';
export const MIDROLL_INTERVAL_SECONDS = 'ads.acc.timeBetweenRollsInSeconds';
